import React, { useEffect, useState } from "react";
import { Snackbar, Alert, TextField, Button, Typography, Grid, Divider } from '@mui/material';
import { useParams } from "react-router-dom";

import { useUserDetailsQuery, useChangePasswordMutation } from "services/user";
import { useSelector } from "react-redux";


const ChangePassword = (props) => {
    const { showChangePassword, setShowChangePassword } = props;
    const { userId } = useParams();
    const requestId = useSelector(state => state.user.requestId);
    const [disableButton, setDisableButton] = useState(false);
    const [newPassword, setChangePassword] = useState('');

    const [sb, setSB] = useState({ open: false, message: '', duration: 3000, severity: 'error' });

    const handleClose = () => {
        setSB({ ...sb, open: false });
    };

    const [changePassword] = useChangePasswordMutation();

    const handleChangePassword = () => {
        setDisableButton(true);
        changePassword({
            email: userDetails.username,
            password: newPassword
        })
            .unwrap()
            .then(result => {
                setSB({ ...sb, open: true, message: "Password Changed", severity: "success" });
                setDisableButton(false);
            })
            .catch(err => {
                setSB({ ...sb, open: true, message: err.message });
                setDisableButton(false);
            })
    }

    const { userDetails } = useUserDetailsQuery(
        {
            id: userId,
            requestId: requestId
        },
        {
            skip: !userId,
            selectFromResult: ({ data }) => ({
                userDetails: data || {}
            })
        }
    );

    return (
        <React.Fragment>

            {showChangePassword ?
                <React.Fragment>
                    <Divider sx={{ margin: "10px" }} />
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px" }}>
                        <Grid item md={2}>
                            <Typography variant="h6">Change Password</Typography>
                        </Grid>
                        <Grid item md={5}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                onChange={(event) => setChangePassword(event.target.value)}
                                value={newPassword || ''}
                            />
                        </Grid>
                        <Grid item md={4} sx={{ marginLeft: "10px" }}>
                            <Button
                                disabled={newPassword.length === 0}
                                variant="contained"
                                onClick={() => handleChangePassword()}
                            >
                                Submit
                            </Button>
                            <Button variant="outlined" onClick={() => setShowChangePassword(false)} sx={{ marginLeft: "10px" }}>Cancel</Button>
                        </Grid>
                    </Grid>
                </React.Fragment>
                : ''}


            <Snackbar
                color='error'
                open={sb.open}
                autoHideDuration={sb.duration}
                onClose={handleClose}
                message={sb.message}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    onClose={handleClose}
                    severity={sb.severity}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {sb.message}
                </Alert>
            </Snackbar>
        </React.Fragment>
    )


}

export default ChangePassword;